import { createFileRoute } from '@tanstack/react-router';

import { MarkSchemesPage } from '@/views/admin/mark-schemes/mark-schemes-page.tsx';

export const Route = createFileRoute('/admin/mark-schemes')({
  component: MarkSchemesPage,
});
